export default "__VITE_ASSET__3eb238ba__"